<script>
import {
  ArrowUpIcon,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  GithubIcon,
  YoutubeIcon,
  GitlabIcon,
  MailIcon,
  UserPlusIcon,
  UsersIcon,
  MessageCircleIcon,
  BellIcon,
  ToolIcon,
  UserIcon,
  KeyIcon,
  PhoneIcon,
  BookmarkIcon,
  UserCheckIcon,
  GlobeIcon,
} from "vue-feather-icons";
import countTo from 'vue-count-to';
import appConfig from "@/app.config";
import axios from 'axios';

// 초기세팅
function initialState() {
  return {
    token: "",
    login: {
      idx: 0,
      level: 0,
      nick: "",
      isLogin: false,
    },
    memberInfo: {
      idx: "",
      nick: "",
      name: "",
      password1: "",
      password2: "",
    },
  };
}

export default {
  components: {
    ArrowUpIcon,
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon,
    GithubIcon,
    YoutubeIcon,
    GitlabIcon,
    InstagramIcon,
    MailIcon,
    UserPlusIcon,
    UsersIcon,
    BellIcon,
    ToolIcon,
    UserIcon,
    KeyIcon,
    PhoneIcon,
    BookmarkIcon,
    MessageCircleIcon,
    UserCheckIcon,
    GlobeIcon,
    countTo,
  },
  data() {
    return initialState();
  },
  props: {
    selectedMenu: {
      type: String,
    },
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.first()
  },
  methods: {
    first() {
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token

        this.memberInfo.idx = getLocalStorage.idx
        this.memberInfo.nick = getLocalStorage.nick
        this.memberInfo.name = getLocalStorage.name

        // 레벨 98 이하거나 로그인 안한상태면 첫화면으로
        if (this.login.level < 98) {
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
          this.$router.push('/');
        } else {
          this.readMyMemberInfo()
        }
      } else {
        this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
        this.$router.push('/');
      }
    },
    async readMyMemberInfo() {
      try {
        this.loadingBar(true)
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/read_my_member_info',
          headers: {
            'access-token': this.token
          },
          data: {
            "mb_idx": this.login.idx,
          },
        })
        .then((res) => {
          if (res.data.type == 'success') {
            this.memberInfo.idx = res.data.idx
            this.memberInfo.nick = res.data.nick
            this.memberInfo.name = res.data.name
          } else {
            this.$notify({ type: 'error', duration: 3000, 'title': res.data.status+' 에러', text: res.data.detail })
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
      } finally {
        this.loadingBar(false)
      }
    },
    sendModifyMember() {
      // 글쓴이명과 별명또는실명 빈값 있으면 알려주자
      if (this.memberInfo.nick !=='' && this.memberInfo.name !=='') {
        if (this.memberInfo.password1 == this.memberInfo.password2) {
          this.m_member_modify()
        } else {
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '비밀번호가 서로 일치하지 않습니다.' })
        }
      } else {
        this.$notify({ type: 'error', duration: 2000, title: '실패', text: '모든 칸을 채워주세요' })
      }
    },
    // 회원정보 수정
    async m_member_modify() {
      try {
        this.loadingBar(true)
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/m_member_modify',
          headers: {
            'access-token': this.token
          },
          data: {
            "mb_idx": this.memberInfo.idx,
            "mb_pw": this.memberInfo.password1,
            "mb_nick": this.memberInfo.nick,
            "mb_name": this.memberInfo.name,
          },
        })
        .then((res) => {
          if (res.data.status == 'success') {
            this.$notify({ type: 'success', duration: 3000, 'title': '성공', text: '로그인정보가 수정되었습니다.'})
          } else {
            this.$notify({ type: 'error', duration: 3000, 'title': res.data.status+' 에러', text: res.data.detail })
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
      } finally {
        this.loadingBar(false)
      }
    },
    loadingBar(val) {
      this.$nextTick(() => {
        const preloader = document.getElementById("preloader");
        const status = document.getElementById("status");
        
        if (preloader && status) {
          if (val === true) {
            preloader.style.display = "block";
            status.style.display = "block";
          } else {
            preloader.style.display = "none";
            status.style.display = "none";
          }
        }
      });
    },
  },
}
</script>

<template>
  <div v-show="memberInfo" class="rounded shadow">
    <div class="p-4 border-bottom">
      <h5 class="text-md-left text-center">내정보 수정</h5>
      <div>
        <div class="row mt-4">
          <div class="col-sm-12 mb-4">
            <button class="btn btn-lg btn-block btn-blue" @click="sendModifyMember()">저장하기</button>
          </div>
          <div class="col-md-12 mt-4 mb-1">
            <div class="p-1 bg-soft-secondary rounded text-dark text-bold font-size-12">
              <span class="text-danger">*글쓴이명 변경</span> <br />
              글쓴이명 변경을 적용을 하시려면 변경 후 다시 로그인해주세요.
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="memberNick" class="text-secondary admin-label">글쓴이명</label>
              <div class="position-relative">
                <user-icon class="fea icon-sm icons"></user-icon>
                <input
                  name="memberNick"
                  id="memberNick"
                  type="text"
                  class="form-control pl-5 text-bold text-dark"
                  v-model="memberInfo.nick"
                  placeholder=""
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="memberNm" class="text-secondary admin-label">별명 또는 실명</label>
              <div class="position-relative">
                <user-icon class="fea icon-sm icons"></user-icon>
                <input
                  name="memberNm"
                  id="memberNm"
                  type="text"
                  class="form-control pl-5 text-bold text-dark"
                  v-model="memberInfo.name"
                  placeholder=""
                />
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-4 mb-1">
            <div class="p-1 bg-soft-secondary rounded text-dark text-bold font-size-12">
              <span class="text-danger">*비밀번호 변경</span> <br />
              비밀번호 까지 변경하고 싶으면 아래 새 비밀번호 칸을 채워주시고, 글쓴이명과 별명또는실명만 변경하고 싶으면 그냥 비워두고 저장하세요
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="password1" class="text-secondary admin-label">새 비밀번호</label>
              <div class="position-relative">
                <key-icon class="fea icon-sm icons"></key-icon>
                <input
                  name="password1"
                  id="password1"
                  type="password"
                  class="form-control pl-5 text-bold text-dark"
                  v-model="memberInfo.password1"
                  placeholder=""
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="password2" class="text-secondary admin-label">새 비밀번호 한 번더</label>
              <div class="position-relative">
                <key-icon class="fea icon-sm icons"></key-icon>
                <input
                  name="password2"
                  id="password2"
                  type="password"
                  class="form-control pl-5 text-bold text-dark"
                  v-model="memberInfo.password2"
                  placeholder=""
                />
              </div>
            </div>
          </div>
        </div>
        <!--end row-->
      </div>
      <!--end form-->
    </div>
  </div>
</template>